module.exports = __webpack_public_path__ + "static/media/lazyaz.d3978a56.jpg";